import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';

import { useStore, useTranslation } from '../../../../../hooks';
import { JackpotTierName } from '../../../../../enums';
import { SidebarJackpotTier } from './jackpot-tier';
import { T } from '../../../../../constants';

interface SidebarJackpotProps {
  onClose: () => void;
}

export const SidebarJackpot: React.FC<SidebarJackpotProps> = observer(({ onClose }) => {

  const { jackpotStore, userActivityStore } = useStore();
  const { jakpotMap } = jackpotStore;

  const t = useTranslation();

  const onDetailsClick = useCallback(() => {
    userActivityStore.sendTrackUserActivity({
      category: UserActivityCategory.PromoTools,
      type: UserActivityTypes.JackpotSideBarMenuCard
    });
    onClose();
    jackpotStore.setJackpotDetailsOpen(true);
  }, [onClose]);

  return (
    <div className="new-sidebar-jackpot-block" onClick={onDetailsClick}>
      <div className="new-jackpot-block-header">
        <span className="new-jackpot-header-text">{t(T.JACKPOT)}</span>
        <button className="details-btn-new" type="button">{t(T.DETAILS)}</button>
      </div>
      <div className="new-jackpot-block-content">
        <SidebarJackpotTier
          className="spades"
          amount={jakpotMap[JackpotTierName.Spade]?.amount || 0}
        />
        <SidebarJackpotTier
          className="hearts"
          amount={jakpotMap[JackpotTierName.Heart]?.amount || 0}
        />
        <SidebarJackpotTier
          className="diamonds"
          amount={jakpotMap[JackpotTierName.Diamond]?.amount || 0}
        />
        <SidebarJackpotTier
          className="clubs"
          amount={jakpotMap[JackpotTierName.Club]?.amount || 0}
        />
      </div>
    </div>
  );
});
